import React, { useState } from "react";
import { Button, TextField } from "@mui/material";
import {
  KeyboardArrowLeft,
  KeyboardArrowRight,
  FirstPage,
  LastPage,
} from "@mui/icons-material";

const PaginationControls = ({
  currentPage,
  totalPages,
  pageSize,
  totalItems,
  onPageChange,
}) => {
  const [gotoPage, setGotoPage] = useState("");

  const getPageRange = () => {
    const start = Math.max(currentPage - 3, 1);
    const end = Math.min(currentPage + 3, totalPages);
    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  };

  const startItem = (currentPage - 1) * pageSize + 1;
  const endItem = Math.min(currentPage * pageSize, totalItems);

  const navButtonStyle = {
    minWidth: "30px",
    height: "30px",
    padding: "5px",
    borderRadius: "50%",
    border: "none",
    color: "#000",
    backgroundColor: "#fff",
    "&:hover": {
      backgroundColor: "#F3F4F6",
    },
  };

  const renderNavButton = (onClick, disabled, icon) => (
    <Button onClick={onClick} disabled={disabled} size="small" sx={navButtonStyle}>
      {icon}
    </Button>
  );

  return (
    <div className="flex flex-col items-center mt-6 gap-1">
      <div className="flex items-center gap-2">
        {renderNavButton(() => onPageChange(1), currentPage === 1, <FirstPage />)}
        {renderNavButton(() => onPageChange(currentPage - 1), currentPage === 1, <KeyboardArrowLeft />)}

        {getPageRange().map((page) => (
          <Button
            key={page}
            onClick={() => onPageChange(page)}
            size="small"
            sx={{
              ...navButtonStyle,
              backgroundColor: page === currentPage ? "#EA580C" : "#fff",
              color: page === currentPage ? "#fff" : "#000",
              fontWeight: page === currentPage ? 600 : 400,
            }}
          >
            {page}
          </Button>
        ))}

        {renderNavButton(() => onPageChange(currentPage + 1), currentPage === totalPages, <KeyboardArrowRight />)}
        {renderNavButton(() => onPageChange(totalPages), currentPage === totalPages, <LastPage />)}

        {/* Goto Input */}
        <TextField
          size="small"
          variant="outlined"
          value={gotoPage}
          onChange={(e) => setGotoPage(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              const page = Number(gotoPage);
              if (page >= 1 && page <= totalPages) {
                onPageChange(page);
                setGotoPage("");
              }
            }
          }}
          placeholder="Go to"
          sx={{ width: 60, mx: 1 }}
        />

        <span className=" text-gray-600">
          of {totalPages?.toLocaleString()} pages
        </span>
      </div>

      <div className=" text-gray-600">
        {startItem}-{endItem} of {totalItems?.toLocaleString()}
      </div>
    </div>
  );
};

export default PaginationControls;
